import { render, staticRenderFns } from "./BriqueChartModalMarker.vue?vue&type=template&id=363a2083&"
import script from "./BriqueChartModalMarker.js?vue&type=script&lang=js&"
export * from "./BriqueChartModalMarker.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports